module.exports = __webpack_public_path__ + "static/img/2345_img_1.6df6f769.png";